import { bugsnag } from 'shared/utils/services/bugsnag';

const CACHE_QUEUE = 'GOAT.home-tab-cache-queue';

interface ICacheQueueItem {
  tabName: string;
  scrollPosition: number;
}

/**
 * [customCache]
 * initializes, reads, and writes the cache that is used to preserve
 * the home tab state
 */

export const customCache = {
  initialize: () => {
    try {
      const cache: ICacheQueueItem[] | [] = JSON.parse(
        window.sessionStorage.getItem(`${CACHE_QUEUE}`),
      );

      if (cache) return;
      window.sessionStorage.setItem(`${CACHE_QUEUE}`, JSON.stringify([]));
    } catch (error) {
      bugsnag(error, { context: 'HomeTabCustomCache initialize' });
    }
  },
  read: () => {
    try {
      const cache: ICacheQueueItem[] | [] = JSON.parse(
        window.sessionStorage.getItem(`${CACHE_QUEUE}`),
      );
      const cachedItemToReturn = cache?.pop();
      window.sessionStorage.setItem(`${CACHE_QUEUE}`, JSON.stringify(cache));
      return cachedItemToReturn;
    } catch (error) {
      bugsnag(error, { context: 'HomeTabCustomCache read' });
    }
  },
  write: (newCacheState: ICacheQueueItem, tabName: string) => {
    try {
      const cacheQueue: ICacheQueueItem[] =
        JSON.parse(window.sessionStorage.getItem(`${CACHE_QUEUE}`)) || [];

      if (cacheQueue.length >= 5) {
        cacheQueue.shift();
      }

      if (
        (cacheQueue.length > 0 && cacheQueue[cacheQueue.length - 1]?.tabName !== tabName) ||
        cacheQueue.length === 0
      ) {
        cacheQueue.push(newCacheState);
      }

      window.sessionStorage.setItem(`${CACHE_QUEUE}`, JSON.stringify(cacheQueue));
    } catch (error) {
      bugsnag(error, { context: 'HomeTabCustomCache write' });
    }
  },
};
